module.exports = __webpack_public_path__ + "media/images/emblems/Muolen-coat_of_arms-f353e44b0acc1fbe02aa1466727c6c3d.svg";